import { render, staticRenderFns } from "./ItemBreakdownRow.vue?vue&type=template&id=453275e4&scoped=true&"
import script from "./ItemBreakdownRow.vue?vue&type=script&lang=js&"
export * from "./ItemBreakdownRow.vue?vue&type=script&lang=js&"
import style0 from "./ItemBreakdownRow.vue?vue&type=style&index=0&id=453275e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453275e4",
  null
  
)

export default component.exports